import type { EnrollmentUserProfile } from '@/api/enrollment-api'
import { useEnrollmentStore } from '@/stores'
import {
  getEnrollmentProfileBootstrapFields,
  type EnrollmentProfileBootstrapFields
} from '../../../utils/enrollmentBootstrapSources'
import type { ApplicationFormData } from '../types'
import { formatBirthDate, normalizeEmail } from '.'

export const getStoredUserProfile = () => {
  return useEnrollmentStore.getState().userProfile
}

export const getApplicationProfileFields = (
  profile: EnrollmentUserProfile | null | undefined
): EnrollmentProfileBootstrapFields => ({
  ...getEnrollmentProfileBootstrapFields(profile),
  email: normalizeEmail(profile?.email || ''),
  birthDate: formatBirthDate(profile?.personalData?.dateOfBirth || '')
})

export const mergeApplicationFormDataWithProfile = (
  formData: ApplicationFormData,
  profile: EnrollmentUserProfile | null | undefined
) => {
  const profileFields = getApplicationProfileFields(profile)
  const nextSmsConsent =
    typeof profileFields.smsConsent === 'boolean' ? profileFields.smsConsent : formData.smsConsent
  const nextTermsAccepted =
    formData.termsAccepted ||
    (formData.smsConsent === false && typeof profileFields.smsConsent === 'boolean'
      ? profileFields.smsConsent
      : false)

  return {
    ...formData,
    firstName: formData.firstName || profileFields.firstName || '',
    lastName: formData.lastName || profileFields.lastName || '',
    middleName: formData.middleName || profileFields.middleName || '',
    phoneNumber: formData.phoneNumber || profileFields.phoneNumber || '',
    email: formData.email || profileFields.email || '',
    addressLine1: formData.addressLine1 || profileFields.addressLine1 || '',
    city: formData.city || profileFields.city || '',
    state: formData.state || profileFields.state || '',
    zipCode: formData.zipCode || profileFields.zipCode || '',
    birthDate: formData.birthDate || profileFields.birthDate || '',
    smsConsent: nextSmsConsent,
    termsAccepted: nextTermsAccepted
  }
}
